import styled from 'styled-components';
import { stripUnit } from 'polished';
import { dropdownSideSpacing } from 'styles/spacings';
import { greenDark, grey200 } from 'styles/colors';
import {
	RadiobuttonUncheckedIcon,
	RadiobuttonCheckedIcon,
} from 'components/icons';

export const Wrapper = styled.div`
	position: relative;
`;

export const Input = styled.input`
	position: absolute;
	left: 0;
	opacity: 0;
	z-index: 1;
	width: 100%;
	height: 100%;
	cursor: pointer;

	&:disabled {
		cursor: default;
	}
`;

const borderLeftSize = 4;

export const Bar = styled.div`
	min-height: 48px;
	display: flex;
	padding: 14px ${dropdownSideSpacing} 14px
		${stripUnit(dropdownSideSpacing) - borderLeftSize}px;
	transition: 200ms ease-in-out;
	transition-property: background-color, border-color;

	${props =>
		props.disabled &&
		`color: ${grey200};
		`};

	& svg {
		margin: -2px 10px 0 2px;
		padding: 0;
	}
`;

export const StyledRadiobuttonUncheckedIcon = styled(RadiobuttonUncheckedIcon)`
	display: none;
	font-size: 22px;
	${Input}:not(:checked) + ${Bar} & {
		display: block;
	}
	${Input}:hover + ${Bar} & {
		fill: ${greenDark};
	}

	${Input}:disabled + ${Bar} & {
		fill: ${grey200};
	}
`;
export const StyledRadiobuttonCheckedIcon = styled(RadiobuttonCheckedIcon)`
	display: none;
	font-size: 22px;
	${Input}:checked + ${Bar} & {
		display: block;
	}

	${Input}:hover + ${Bar} & path:first-child {
		fill: ${greenDark};
	}
`;
